import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert
} from '@mui/material';
import { AccountBalanceWallet as WalletIcon } from '@mui/icons-material';

const CreditWarningDialog = ({ 
  open, 
  onClose, 
  trackName, 
  requiredAmount, 
  onAddCredit 
}) => {
  
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WalletIcon color="warning" />
        Insufficient Credit
      </DialogTitle>
      
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          You don't have enough credit to play this track.
        </Alert>
        
        <Typography variant="body1" sx={{ mb: 2 }}>
          To play <strong>{trackName}</strong>, you need at least <strong>${requiredAmount}</strong> per minute.
        </Typography>
        
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Add credit to your account to continue enjoying music on Tuneswell.
        </Typography>
        
        <Box sx={{ 
          bgcolor: 'grey.100', 
          p: 2, 
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'grey.300',
          '& .MuiTypography-root': {
            color: 'rgba(0, 0, 0, 0.87) !important'
          }
        }}>
          <Typography variant="body2">
            <strong>How it works:</strong> You're charged $0.01 per minute of music you listen to. 
            80% goes to artists, 18% to the platform, and 2% to curators who help you discover music.
          </Typography>
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button 
          onClick={onClose}
          variant="outlined"
        >
          Cancel
        </Button>
        <Button 
          onClick={onAddCredit}
          variant="contained"
          color="primary"
        >
          Add Credit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreditWarningDialog;